import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const DefaultPortalIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 54.905 55',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <defs>
      <clipPath id="default-portal">
        <circle
          fill="#eff2f7"
          cx="26"
          cy="26"
          r="26"
          transform="translate(510.741 -189.672)"
        />
      </clipPath>
    </defs>
    <g transform="translate(-1713 -127)">
      <circle
        fill="#eff2f7"
        cx="26"
        cy="26"
        r="26"
        transform="translate(1714 130)"
      />
      <g transform="translate(1203.259 319.672)">
        <path
          fill="#4b6f95"
          d="M561.495-162.068l-24.3-24.3-24.3,24.3-3.151-3.151,27.452-27.452,27.453,27.452Z"
          transform="translate(0 0)"
        />
        <g className=".c-default-portal">
          <path
            fill="#4b6f95"
            d="M516.714-168.629v39.451h11.657v-32.81a5.434,5.434,0,0,1,5.435-5.435h0a5.435,5.435,0,0,1,5.436,5.435v32.81H550.9v-39.451l-17.094-16.834Z"
            transform="translate(3.387 3.502)"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default DefaultPortalIcon;
